import "./index.scss";
import React from "react";

import { Avatar, money, shortName } from "../atoms";

// "Last sold" and "most expensive" were two copies of the same card down to the
// column widths, so they are one component told apart by its label.
const ResultCard = ({ label, player }) => {
  const sold = player?.name;

  return (
    <section className="result-card">
      <span className="au-label">{label}</span>

      {sold ? (
        <div className="result-card-body">
          <Avatar name={player?.name} src={player?.image} size={34} />
          <div className="result-card-text">
            <span className="result-card-name">{shortName(player?.name)}</span>
            <span className="result-card-team">
              {player?.lastBidBy?.team || "—"}
            </span>
          </div>
          <span className="result-card-price">{money(player?.soldAt)}</span>
        </div>
      ) : (
        <p className="result-card-none">Nothing sold yet</p>
      )}
    </section>
  );
};

export default ResultCard;
